import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from 'redux/store';
import { isReady } from 'redux/hardware/hardware.selectors';
import { displayWaitingForBadge } from 'redux/customer/customer.actions';
import Home from './Home.page';

const mapStateToProps = (state: RootState): { isReady: boolean } => ({
  isReady: isReady(state),
});

const mapDispatchToProps = {
  displayWaitingForBadge,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Home));
